import React from 'react';
import Grid from "@mui/material/Grid2";
import Logo from "../../../files/img/logo/logo-square.png";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";

function AppLoader({ classes }) {
    return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            className={classes.appLoader}
        >
            <Grid item xs={12}>
                <div className="main-loader"></div>
            </Grid>
        </Grid>
    );
}

export default withStyles(Styles)(AppLoader);
